<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" :max-width="maxWidth">
      <v-card light>
        <div style="display: flex; justify-content: center; flex-direction: column; text-align: center; padding-top: 10px;">
          <v-icon :color="iconColor" :size="iconSize">{{ icon }}</v-icon>
          <h2 class="">{{ title }}</h2>
          <v-card-text>{{ text }}</v-card-text>
        </div>

        <v-card-actions>
          <v-btn color="error" flat @click="dialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="submit">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    functionYes: Function,
    text: {
      type: String,
      default: '¿Seguro que desea continuar?'
    },
    title: {
      type: String,
      default: 'Confirmación'
    },
    maxWidth: {
      type: String,
      default: '290'
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      dialog: false
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    },
    submit () {
      this.dialog = false
      this.functionYes()
    }
  }
}
</script>
